// src/components/Layout.js
import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import MenuPrincipal from './Menu/MenuPrincipal';
import Footer from './Footer/Footer';
import WhatsAppButton from './WhatsAppButton';
import Loading from './Loading/Loading';

const Layout = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simula o carregamento (substitua por sua lógica real)
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000); // 2 segundos para demonstração

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="site-container">
      {isLoading && <Loading />}
      
      <MenuPrincipal />
      <main className="site-content">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default Layout;